import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Card element, used to wrap content and display a white background
 *
 * @slot - Unnamed slot (default slot)
 *
 */
let SDBLayoutDivider = class SDBLayoutDivider extends LitElement {
    render() {
        return html ` <hr /> `;
    }
};
SDBLayoutDivider.styles = [
    elements,
    css `
            :host hr {
                border: 0;
                height: 1px;
                background: var(--element-lightgrey);
            }

            :host([light]) hr {
                border: 0;
                height: 1px;
                background: rgba(255, 255, 255, 0.5);
            }
        `,
];
SDBLayoutDivider = __decorate([
    customElement('sdb-layout-divider')
], SDBLayoutDivider);
export { SDBLayoutDivider };
//# sourceMappingURL=sdb-layout-divider.js.map